/* Marquee is intentionally CSS-only. Removing the old DOM rebuild avoids a visible restart/jump after page load. */

/* Fast product image lightbox navigation. Uses the already-rendered image URLs and does not trigger the gallery behind the popup. */
(function(){
  var lightbox=document.getElementById('productLightbox');
  var dialog=lightbox&&lightbox.querySelector('.product-lightbox-dialog');
  var content=document.getElementById('productLightboxContent');
  var stage=document.getElementById('productStage');
  if(!lightbox||!dialog||!content||!stage)return;

  var images=Array.prototype.slice.call(stage.querySelectorAll('.product-zoomable-image'));
  if(images.length<2)return;

  var currentIndex=0;
  var lightboxImage=document.createElement('img');
  lightboxImage.className='product-lightbox-fast-image';
  lightboxImage.decoding='async';
  lightboxImage.style.cursor='default';
  lightboxImage.style.pointerEvents='auto';

  var prev=document.createElement('button');
  var next=document.createElement('button');
  prev.type='button'; next.type='button';
  prev.className='product-lightbox-nav product-lightbox-prev';
  next.className='product-lightbox-nav product-lightbox-next';
  prev.setAttribute('aria-label','Previous product image');
  next.setAttribute('aria-label','Next product image');
  prev.innerHTML='&#8249;'; next.innerHTML='&#8250;';
  dialog.appendChild(prev); dialog.appendChild(next);

  function imageUrl(source){return source.currentSrc||source.src;}
  function indexOfImage(img){var index=images.indexOf(img);return index<0?0:index;}
  function preload(index){
    var source=images[(index+images.length)%images.length];
    if(!source)return;
    var loader=new Image();
    loader.src=imageUrl(source);
  }
  function preloadNeighbors(){preload(currentIndex-1);preload(currentIndex+1);}

  function render(index){
    currentIndex=(index+images.length)%images.length;
    var source=images[currentIndex];
    lightboxImage.alt=source.alt||'';
    lightboxImage.src=imageUrl(source);
    if(content.firstElementChild!==lightboxImage)content.replaceChildren(lightboxImage);
    content.scrollTop=0;
    preloadNeighbors();
  }

  stage.addEventListener('click',function(event){
    var img=event.target.closest('.product-zoomable-image');
    if(!img)return;
    currentIndex=indexOfImage(img);
    preloadNeighbors();
  });

  prev.addEventListener('click',function(event){event.stopPropagation();if(!lightbox.hidden)render(currentIndex-1);});
  next.addEventListener('click',function(event){event.stopPropagation();if(!lightbox.hidden)render(currentIndex+1);});
  document.addEventListener('keydown',function(event){
    if(lightbox.hidden)return;
    if(event.key==='ArrowLeft'){event.preventDefault();render(currentIndex-1);}
    else if(event.key==='ArrowRight'){event.preventDefault();render(currentIndex+1);}
  });

  var warm=function(){images.forEach(function(_,index){preload(index);});};
  if('requestIdleCallback' in window)requestIdleCallback(warm,{timeout:1200});
  else setTimeout(warm,250);
})();
